// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1GmCb","boxTitle":"Qualiphy_boxTitle__eUhtB","box":"Qualiphy_box__f0kva","toggleWrap":"Qualiphy_toggleWrap__380bR"};